import './sass/style.scss';
import BurgerMenu from './scripts/BurgerMenu';
import BeforeAfter from './scripts/BeforeAfter/BeforeAfter';
import BaSlider from './scripts/BaSlider';
import CardModal from './scripts/CardModal';
import CarouselGallery from './scripts/CarouselGallery/CarouselGallery';
import PromoSlider from './scripts/slider';
import FactsSlider from './scripts/FactsSlider';
import Price from './scripts/Price/Price';
import HorizontalScroll from './scripts/HorizontalScroll/HorizontalScroll';
import ContactModal from './scripts/ContactModal/ContactModal';
import Lang from './scripts/Lang';

const burgerMenu = new BurgerMenu();
burgerMenu.run();
// Инициализируем Lang только для обработки переключения языков
new Lang();
new PromoSlider('.promo-slider');
new FactsSlider('.facts-slider');
// Инициализация модального окна контактов
const contactModal = new ContactModal('.btn_contact');
new Price(contactModal);
new BeforeAfter();
new BaSlider('.before-after__slider');
new CardModal('.doctor-card');
const carouselGallery = new CarouselGallery();
carouselGallery.run();

// Инициализация горизонтальной прокрутки для галереи клиники
new HorizontalScroll('.clinic-pics__pics-container');
